import React from 'react';
import {Button, Card, Col, Form, FormControl, FormGroup, FormLabel, ListGroup, Modal, Row} from "react-bootstrap";
import {Glyph} from "../common/Glyph";
import {cols, operators} from "./MarketingQueryView";
import MarketingQueryFilterRow from "./MarketingQueryFilterRow";

export default class MarketingQueryConfigModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            config: {...props.config},
            validated: false
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.show && !prevProps.show) {
            this.setState({
                config: {...this.props.config},
                validated: false
            })
        }
    }

    setConfigField = (name, value) => {
        let newConfig = {...this.state.config};
        newConfig[name] = value;
        this.setState({config: newConfig});
    }

    changeOrderCol = (i, key) => {
        let newConfig = {...this.state.config}; // Copy config
        let newOrders = [...newConfig.orders]; // Copy orders array
        newOrders[i] = {...newOrders[i]}; // Make a copy of this too
        newOrders[i].col = cols[key];
        newConfig.orders = newOrders;
        this.setState({config: newConfig});

    }

    removeOrder = (i) => {
        let newConfig = {...this.state.config};
        let newOrders = [...newConfig.orders];
        newOrders.splice(i, 1);
        newConfig.orders = newOrders;
        this.setState({config: newConfig});
    }

    addOrder = () => {
        let newConfig = {...this.state.config};
        let newOrders = [...newConfig.orders];
        newOrders.push({col: cols.specialty, desc: false});
        newConfig.orders = newOrders;
        this.setState({config: newConfig});
    }

    toggleDirection = (i) => {
        let newConfig = {...this.state.config};
        let newOrders = [...newConfig.orders];
        newOrders[i] = {...newOrders[i]}; // Make a copy of this too
        newOrders[i].desc = !newOrders[i].desc;
        newConfig.orders = newOrders;
        this.setState({config: newConfig});
    }

    addFilter = () => {
        let newConfig = {...this.state.config};
        newConfig.filters = [...newConfig.filters];
        newConfig.filters.push({col: cols.active, operator: operators.isTrue});
        this.setState({config: newConfig});
    }

    filterChanged = (i, f) => {
        let newConfig = {...this.state.config};
        newConfig.filters = [...newConfig.filters];
        newConfig.filters[i] = f;
        this.setState({config: newConfig});
    }

    removeFilter = (i) => {
        let newConfig = {...this.state.config};
        newConfig.filters = [...newConfig.filters];
        newConfig.filters.splice(i, 1);
        this.setState({config: newConfig});
    }

    render() {
        let config = this.state.config;
        let colArray = Object.entries(cols).map(c => c[1]);

        return <Modal size={"xl"} show={this.props.show} onHide={this.props.onCancel}>
            <Modal.Header>
                <Modal.Title>Query Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={this.state.validated} onSubmit={() => false}>
                    <Row>
                        <FormGroup as={Col} md={6}>
                            <FormLabel>Query Type:</FormLabel>
                            <FormControl custom as={"select"} name={"entityType"} value={config.entityType} onChange={(e) => this.setConfigField(e.target.name, e.target.value)}>
                                <option value={"Provider"}>Provider</option>
                                <option value={"Practice"}>Practice</option>
                            </FormControl>
                        </FormGroup>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <Card>
                                <Card.Body className={"p-2"}>
                                        <Row>
                                            <Col>
                                                Filters:

                                                <Glyph name={"plus-lg"} style={{float: "right"}} className={"clickable"} onClick={this.addFilter}/>
                                                <ListGroup variant="flush">
                                                    { config.filters && config.filters.map((f,i) => <ListGroup.Item key={"filter_"+i}>
                                                        <MarketingQueryFilterRow index={i} cols={colArray} filter={f} onChange={(o) => this.filterChanged(i, o)} onRemove={() => this.removeFilter(i)}/>
                                                    </ListGroup.Item>)}
                                                </ListGroup>
                                            </Col>
                                        </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card>
                                <Card.Body className={"p-2"}>
                                        <Row>
                                            <Col>
                                                Order By:
                                                <Glyph name={"plus-lg"} style={{float: "right"}} className={"clickable"} onClick={this.addOrder}/>
                                                <ListGroup variant="flush">
                                                    { config.orders && config.orders.map((o,i) => <ListGroup.Item key={"order_"+o.col.key}>
                                                        <Row>
                                                            <Col>
                                                                {i+1}.
                                                                <FormControl inline={""} custom as={"select"} value={o.col.key} onChange={(e) => this.changeOrderCol(i, e.target.value)} className={"d-inline-block w-75 ml-2"}>
                                                                    {colArray.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
                                                                </FormControl>
                                                                <Glyph name={o.desc ? "chevron-down" : "chevron-up"} className={"ml-3 clickable"} label={o.desc ? "Descending" : "Ascending"} onClick={() => this.toggleDirection(i)}/>
                                                            </Col>
                                                            <Col md={"auto"}>
                                                                <Glyph name={"x-lg"} className={"clickable text-right"} label={"Remove"} onClick={() => this.removeOrder(i)}/>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>)}
                                                </ListGroup>
                                            </Col>
                                        </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onCancel}>
                    Cancel
                </Button>
                <Button variant="dark" onClick={() => this.props.onOk(this.state.config)}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    }
}